import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './Button';
import { Sheet, SheetContent, SheetTrigger } from './Sheet';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    label: 'Services',
    href: '#services'
  }, {
    label: 'About',
    href: '#about'
  }, {
    label: 'Reviews',
    href: '#reviews'
  }, {
    label: 'Contact',
    href: '#contact'
  }];
  const scrollToSection = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setIsOpen(false);
    }
  };
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-bg/90 backdrop-blur-md shadow-lg' : 'bg-transparent'}`} data-id="element-70">
      <div className="container mx-auto px-6 lg:px-8" data-id="element-71">
        <div className="flex items-center justify-between h-20" data-id="element-72">
          <div className="font-heading-alt text-white text-xl md:text-2xl font-bold tracking-tight" data-id="element-73">
            Phoenix Tree Experts
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8" data-id="element-74">
            {navLinks.map(link => <button key={link.href} onClick={() => scrollToSection(link.href)} className="text-white/90 hover:text-brand-green transition-colors font-body" data-id="element-75">
                {link.label}
              </button>)}
            <Button onClick={() => scrollToSection('#contact')} className="bg-brand-orange hover:bg-brand-orange/90 text-white font-body font-semibold h-12 px-6" data-id="element-76">
              Get a Free Quote
            </Button>
          </div>

          {/* Mobile Menu */}
          <Sheet open={isOpen} onOpenChange={setIsOpen} data-id="element-77">
            <SheetTrigger asChild className="md:hidden" data-id="element-78">
              <Button variant="ghost" size="icon" className="text-white" data-id="element-79">
                <Menu className="h-6 w-6" data-id="element-80" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" showCloseButton={false} className="w-full bg-brand-bg border-l border-brand-green/20" data-id="element-81">
              <button type="button" onClick={() => setIsOpen(false)} aria-label="Close menu" className="absolute top-6 right-6 flex items-center justify-center h-12 w-12 rounded-full border-2 border-brand-green text-white hover:bg-brand-green hover:text-brand-bg transition-colors" data-id="element-82">
                <X className="h-6 w-6" data-id="element-83" />
              </button>
              <div className="flex flex-col items-center justify-center gap-8 h-full" data-id="element-84">
                {navLinks.map(link => <button key={link.href} onClick={() => scrollToSection(link.href)} className="text-white text-2xl font-body hover:text-brand-green transition-colors text-center" data-id="element-85">
                    {link.label}
                  </button>)}
                <Button onClick={() => scrollToSection('#contact')} className="bg-brand-orange hover:bg-brand-orange/90 text-white font-body font-semibold h-12 px-8 mt-2" data-id="element-86">
                  Get a Free Quote
                </Button>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </nav>;
}